import useNavigationStore from '@src/stores/navigationStore';

import styles from './CompanyMisc.module.scss';
import BlockTitle from '@src/components/_shared/UI/BlockTitle';
import BackButton from '@src/components/_shared/BackButton';
import Container from '@src/components/_shared/Container';
import ValidateChoiceButton from '@src/components/_shared/UI/ValidateChoiceButton';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { useState } from 'react';
import WarningModal from '@src/components/_shared/WarningModal';
import VirtualAssistant from '@src/assets/VirtualAssistant.png';
import useRegistrationStore from '@src/stores/registrationStore';
import { getPhoneNumber } from '@src/utilities/functions';


export default function CompanyMisc() {
    const { setSection, setBlock } = useNavigationStore();
    const { registration } = useRegistrationStore();
    const [notAllowed, setNotAllowed] = useState<boolean>(false);
    const [isFrenchEntity, setIsFrenchEntity] = useState<boolean>(false);
    const [notFixedCapital, setNotFixedCapital] = useState<boolean>(false);


    const _onGoBack = () => {
        setSection(2)
        setBlock('Nationality')
    };

    if (isFrenchEntity && !notFixedCapital) {
        return (
            <Container>
                <BackButton onClick={() => setIsFrenchEntity(false)}/>
                <BlockTitle title="La société a-t-elle un capital fixe ?" />
                <Subtitle content="Veuillez choisir l’une des réponses" />
                <div className={styles.buttons}>
                    <ValidateChoiceButton title="Oui" onValidate={() => setBlock('SirenNumber')} />
                    <ValidateChoiceButton title="Non" onValidate={() => setNotFixedCapital(true)} />
                </div>
            </Container>
        )
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Le siège social de la société est-il situé en France ?" />
            <Subtitle content="Les conditions d’usage et de service dépendent du pays de résidence." />
            <div className={styles.buttons}>
                <ValidateChoiceButton title="Oui" onValidate={() => setIsFrenchEntity(true)} />
                <ValidateChoiceButton title="Non" onValidate={() => setNotAllowed(true)} />
            </div>
            {notAllowed ?
                <WarningModal
                    image={VirtualAssistant}
                    show={notAllowed}
                    content={`Le pays de résidence de votre société ne vous permet malheureusement pas de devenir client ${registration.partner_informations.is_partner ? 'Direct Securities' : 'Bourse Direct'}. Nous en sommes désolés et vous prions de contacter les services administratifs concernés pour plus d’informations au ${getPhoneNumber(registration.partner_informations.is_partner, registration.partner_informations.brand.code)}.`}
                    onValidate={() => setNotAllowed(false)}
                />
                :null
            }
            {notFixedCapital ?
                <WarningModal
                    image={VirtualAssistant}
                    show={notFixedCapital}
                    content={`En raison de votre capital, l'ouverture de compte en ligne n'est pas possible. Nous vous invitons à contacter le service de la relation client au ${getPhoneNumber(registration.partner_informations.is_partner, registration.partner_informations.brand.code)}.`}
                    onValidate={() => setNotFixedCapital(false)}
                />
                : null}
        </Container>
    );
}
